/**
 * Helper para obtener la versión de la aplicación
 * Extrae la versión directamente del package.json
 */

// Importamos el package.json para obtener la versión
import packageJson from '../../../../package.json';

export class AppVersionHelper {
  /**
   * Obtiene la versión actual de la aplicación desde package.json
   * @returns {string} La versión de la aplicación (ej: "0.1.77")
   */
  static getVersion(): string {
    return packageJson.version;
  }

  /**
   * Obtiene la versión formateada para mostrar en UI
   * @returns {string} La versión formateada (ej: "v0.1.77")
   */
  static getFormattedVersion(): string {
    return `v${packageJson.version}`;
  }

  /**
   * Obtiene información completa de la aplicación
   * @returns {object} Objeto con nombre y versión de la aplicación
   */
  static getAppInfo(): { name: string; version: string; formattedVersion: string } {
    return {
      name: packageJson.name,
      version: packageJson.version,
      formattedVersion: `v${packageJson.version}`,
    };
  }
}
